<!-- {{roomType.price}} -->
<form #roomForm="ngForm">
    <div class="row">

        <div class="col-sm-2 col-md-2 col-sm-media">

            <div class="input-group">
                <input class="form-control" required (change)="inputField($event, index)" style="float:none" placeholder="dd.mm.yyyy" ngx-mydatepicker name="mydate" [(ngModel)]="roomType.newStart" [options]="myOptions" id="aux-{{index}}-service-new" #dp="ngx-mydatepicker"
                    (InputFieldChanged)="inputField($event, index)" (dateChanged)="setEndTermin($event)" />
                <span class="input-group-btn">
            <button type="button" class="btn btn-default" (click)="dp.clearDate()">
              <i class="glyphicon glyphicon-remove"></i>
            </button>
            <button type="button" class="btn btn-default" (click)="dp.toggleCalendar()">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
            </div>
            <div *ngIf="dp.invalid && (dp.dirty || dp.touched)" class="alert alert-danger">
                <div *ngIf="dp.errors.required">
                    Must be in format "dd.MM.yyyy"
                </div>
            </div>
        </div>
        <div class="col-sm-1  col-md-1">

        </div>
        <div class="col-sm-2 col-md-2">
            <input class='end-date' [ngModel]="roomType.end  | date:'dd.MM.yyyy'" readonly name="aux.{{index}}.service" type="text" class="form-control" id="aux-{{index}}-service">
        </div>
        <div class="col-sm-2 col-sm-media col-md-2">
            <select [(ngModel)]="roomType.roomType" required (change)="switchRoomType(roomType.roomType)" name="aux.{{index}}.type" class="form-control" id="aux-{{index}}-type">
          <option *ngFor="let pT of roomTypes" selected="i" value="{{pT.code}}">{{pT.name}}</option>
        </select>
            <select [(ngModel)]="roomType.roomType1" (change)="switchRoomType1(roomType.roomType1)" name="aux.{{index}}.type1" class="form-control" id="aux-{{index}}-type1">
          <option *ngFor="let pT of roomTypes" selected="i" value="{{pT.code}}">{{pT.name}}</option>
        </select>
        </div>
        <!-- ^[+-]?\d+(\,)\d{2}$ -->
        <div class="col-sm-2 col-md-2 col-sm-media-price ">
            <div class="input-group">
                <input class="form-control" currencyMask [(ngModel)]="roomType.currencyMaskPrice" [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: ' €' }" (ngModelChange)="displayCurrentValue($event, 'SGL')" name="price-one" />
            </div>
            <!-- <div class="input-group">
                <input type="text" class="form-control" [required]="!roomType.price1ForAdmin" pattern="^(?:([+-]?\d+(\,)\d{2})|(\d+))$" #price="price" id="price" name="price" [(ngModel)]="roomType.priceForAdmin" (change)="SetValueOfPrice(roomType.price, 'SGL')" (ngModelChange)="roomType.price=$event"
                    #price="ngModel">
                <span class="input-group-addon">
                &euro;
            </span>
            </div>
            <div *ngIf="price.invalid && (price.dirty || price.touched)" class="alert alert-danger">
                <div *ngIf="price.errors.required">
                    Must have one price
                </div>
                <div *ngIf="price.errors.pattern">
                    Must be in correct format
                </div>
            </div> -->
            <!-- <div class="input-group">
                <input type="text" class="form-control" [required]="!roomType.priceForAdmin" pattern="^(?:([+-]?\d+(\,)\d{2})|(\d+))$" id="price1" name="price1" [(ngModel)]="roomType.price1ForAdmin" (change)="SetValueOfPrice(roomType.price1, 'DBL')" (ngModelChange)="roomType.price1=$event"
                    #price1="ngModel">
                <span class="input-group-addon">
                    &euro;
                </span>
            </div> -->
            <div class="input-group">
                <input class="form-control" currencyMask [(ngModel)]="roomType.currencyMaskPrice1" [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: ' €' }" (ngModelChange)="displayCurrentValue($event, 'DBL')" name="price-two" />
            </div>
        </div>
        <div class="col-sm-1 col-md-1">
            <input [(ngModel)]="roomType.active" name="aux.{{index}}.active" type="checkbox" class="form-control active-margin" id="aux-{{index}}-active">
            <input [(ngModel)]="roomType.active1" name="aux.{{index}}.active1" type="checkbox" class="form-control active-margin" id="aux-{{index}}-active1">
        </div>
        <div class="col-sm-2 col-md-2 pt-2 text-center">
            <i class="fa fa-clone" style="cursor: pointer;" alt="Kopieren" title="{{'simple-travel-form.hint.copy.entry' | translate}}" (click)="copyRoom(roomType, index)"></i>
            <i class="fa fa-trash" style="cursor: pointer;" alt="Löschen" title="{{'simple-travel-form.hint.delete.entry' | translate}}" title="Löschen" (click)="deleteRoom(roomType, index)"></i>
        </div>
    </div>
    <button hidden="true" (click)="sendForm(roomForm.valid)" id="room-{{index}}">TEST</button>
</form>


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-room-types/simple-travel-form-room-types.component.html